<script lang="ts">

export let href: string;

</script>

<svelte:head>
    <link rel="canonical" href={href} />
</svelte:head>